import { ProjectLogisticsFromValues, ProjectLogisticsRequest } from '@modules/orders-and-trips/types/project-logistics';
import { getProjectLogisticPayloadValue } from '@modules/orders-and-trips/helpers/project-logistics/get-project-logistic-payload-value';

export const getProjectLogisticPayload = (fields: ProjectLogisticsFromValues): ProjectLogisticsRequest => {
  return Object.entries(fields).map(([name, value]) => {
    return { name, value: getProjectLogisticPayloadValue(value) };
  });
};
